<template>
  <div class="-mass-produce-generating-state wt2-color-negative">
    <span class="-title">
      {{ 'fullPreview.GENERATING_PREVIEW' | culture }}<wt-ellipsis-animation />
    </span>
    <span class="-subtitle"> It's almost ready </span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.-mass-produce-generating-state {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .-title {
    font-size: 28px;
    font-weight: 300;
    margin-bottom: 10px;
  }
  .-subtitle {
    font-size: 20px;
    font-weight: 300;
  }
}
</style>
